class TireSizes {
  constructor(tireSizeData) {
    this.tireSizeData = tireSizeData;
  }

  getTireFill(tireSize, type) {
    /*
    if three num:
      convert to both metric and std three num
    get matches
    if matches === 0
      get approx matches

    reduce to get avg of props for each notation
    get avg of matches for each notation and return
    return obj {
      matchType: "APPROX" || "EXACT" || "NOMATCH",
      data: {
        notation: "Metric" || "Standard" : {
          avgs: avgs
        },
        notation: {
          avgs
        }f
    */
    console.log("tire size ", tireSize);
    console.log("type ", type);
    let stdThreeNumTireSize = null;
    let matchType = "exact";
    if (tireSize.notation === "metric") {
      stdThreeNumTireSize = {
        measurements: {
          tireDia: tireSize.measurements.tireWidth,
          rimDia: tireSize.measurements.rimDia,
          tireWidth: tireSize.measurements.aspectRatio,
        },
        construction: tireSize.construction,
        notation: "stdThreeNums",
      };
    }

    let matchingSizes = this.tireSizeData.filter((tempTireSize) => {
      return (
        TireSizes.isSameTireSizeAndNotation(tireSize, tempTireSize) ||
        TireSizes.isSameTireSizeAndNotation(stdThreeNumTireSize, tempTireSize)
      );
    });

    if (matchingSizes.length === 0) {
      matchType = "approx";
      matchingSizes = this.getApproxMatches(tireSize, stdThreeNumTireSize);
    }

    if (matchingSizes.length === 0) {
      return { ...tireSize, matchType: "noMatch" };
    }

    const sizes = matchingSizes.reduce(this.combineToUniqueTireSizes, {});
    console.log("sizes ", sizes);
    return { ...sizes, matchType };

    // return [
    //   {
    //     matchType: { isExact: true, isApprox: false },
    //     tireSize: matchingSizes[0].tireSize,
    //     liters: liters,
    //     USGals: USGals,
    //     impGals: Math.round(liters * 0.219969204701183),
    //     lbs: lbs,
    //     kgs: Math.round(lbs * 0.453592),
    //   },
    // ];
    // }
    // if (Object.keys(approxMatches).length > 0) {
    //   approxMatches.matchType = { isExact: false, isApprox: true };
    //   return approxMatches;
    // } else {
    //   tireSize.matchType = { isExact: false, isApproxMatch: false };
    //   return tireSize;
    // }
  }

  getAvgOfProp(arr, propName) {
    return Math.round(
      arr.reduce((sum, e) => sum + Number(e[propName]), 0) / arr.length
    );
  }

  static isSameTireSize(tireSizeA, tireSizeB) {
    return (
      TireSizes.areSameTireMeasurements(tireSizeA, tireSizeB) &&
      tireSizeA.construction === tireSizeB.construction
    );
  }

  static isSameTireSizeAndNotation(origTireSize, tempTireSize) {
    return (
      origTireSize !== null &&
      origTireSize !== undefined &&
      TireSizes.isSameTireSize(origTireSize, tempTireSize) &&
      tempTireSize.notation === origTireSize.notation
    );
  }

  getApproxMatches(tireSizeA, tireSizeB = null) {
    return this.tireSizeData.filter((tempTireSize) => {
      return (
        (TireSizes.areSameTireMeasurements(tireSizeA, tempTireSize) &&
          tempTireSize.notation === tireSizeA.notation) ||
        (tireSizeB !== null &&
          TireSizes.areSameTireMeasurements(tireSizeB, tempTireSize) &&
          tempTireSize.notation === tireSizeB.notation)
      );
    });
    // const matches = tempMatches.reduce(this.combineToUniqueTireSizes, {});

    // return this.getAvgOfMatches(matches);
  }

  static areSameTireMeasurements(tireSizeA, tireSizeB) {
    for (let prop in tireSizeA.measurements) {
      if (
        String(tireSizeA.measurements[prop]) !==
        String(tireSizeB.measurements[prop])
      ) {
        return false;
      }
    }
    return true;
  }

  getAvgOfMatches(matches) {
    return Object.keys(matches).map(
      (k) =>
        (matches[k] = {
          ...matches[k],
          tireSize: matches[k].sizes[0].tireSize,
          USGals: this.getAvgOfProp(matches[k].sizes, "USGals"),
          impGals: this.getAvgOfProp(matches[k].sizes, "impGals"),
          lbs: this.getAvgOfProp(matches[k].sizes, "lbs"),
          liters: this.getAvgOfProp(matches[k].sizes, "liters"),
          kgs: this.getAvgOfProp(matches[k].sizes, "kgs"),
        })
    );
  }

  getTireSizeType(tireSize) {
    if (Object.keys(tireSize.measurements).includes("tireDia")) {
      return "stdThreeNums";
    } else if (Object.keys(tireSize.measurements).includes("aspectRatio")) {
      return "metric";
    } else {
      return "stdThreeNums";
    }
  }

  combineToUniqueTireSizes(acc, curTireSize) {
    const msrmntProps = ["kgs", "lbs", "impGals", "USGals", "liters"];
    const tsKey = `${curTireSize.notation}${curTireSize.construction}`;
    console.log(tsKey);
    if (Object.keys(acc).includes(tsKey)) {
      msrmntProps.forEach((prop) => {
        acc[tsKey][prop] = TireSizes.computeAvg(acc[tsKey], prop, curTireSize);
      });
      acc[tsKey].numFillsFound++;
    } else {
      acc[tsKey] = {
        numFillsFound: 1,
        measurements: { ...curTireSize.measurements },
      };
      [...msrmntProps, "tireSize", "construction"].forEach(
        (k) => (acc[tsKey][k] = curTireSize[k])
      );
    }
    return acc;
  }

  static computeAvg(accVals, prop, curVals) {
    return (
      (accVals.numFillsFound * accVals[prop] + curVals[prop]) /
      (accVals.numFillsFound + 1)
    );
  }
}

export default TireSizes;
